import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const InjectGoogleGPTScript: React.FC<PropType> = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" crossOrigin="anonymous"></script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-4PC8CJJSCG" crossOrigin="anonymous"></script>
      </Helmet>
    </HelmetProvider>
  )
}

interface PropType {}

export default InjectGoogleGPTScript
